import axios from 'axios'

export const getOrderSummary = async (token, idProduct) => await axios.get(`${process.env.REACT_APP_API}/get-order-summary/${idProduct}`, {
    headers: { Authorization: `bearer ${token}` },
    timeout: process.env.REACT_APP_AXIO_TIMEOUT
})